import { gql } from 'apollo-angular';

const FILTER_ALERTS = gql`
  query Alert(
    $company: String!
    $firstAlertDateTime: DateTime
    $lastAlertDateTime: DateTime
    $alertCode_In: [AlertCode]
    $installationReference: String
    $alertState: AlertState
    $limit: Int
    $offset: Int
  ) {
    alert(
      company: $company
      firstAlertDatetime: $firstAlertDateTime
      lastAlertDatetime: $lastAlertDateTime
      alertCode_In: $alertCode_In
      installationReference: $installationReference
      alertState: $alertState
      limit: $limit
      offset: $offset
    ) {
      edges {
        node {
          id
          firstAlertDatetime
          lastAlertDatetime
          alertCode
          eventsCount
          alertDescription
          installationReference
          installationId
          deviceSerialNumber
          deviceMacAddress
          latitude
          longitude
          fwVersion
          lastGatewayRoute
          ocurrences
          alertState
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

const GET_ALERT_BY_ID = gql`
  query Alert(
    $company: String!
    $firstAlertDateTime: DateTime
    $lastAlertDateTime: DateTime
    $alertCode_In: [AlertCode]
    $installationReference: String
    $alertState: AlertState
    $limit: Int
    $offset: Int
  ) {
    alert(
      company: $company
      firstAlertDatetime: $firstAlertDateTime
      lastAlertDatetime: $lastAlertDateTime
      alertCode_In: $alertCode_In
      installationReference: $installationReference
      alertState: $alertState
      limit: $limit
      offset: $offset
    ) {
      edges {
        node {
          id
          firstAlertDatetime
          lastAlertDatetime
          alertCode
          eventsCount
          alertDescription
          installationReference
          installationId
          deviceSerialNumber
          deviceMacAddress
          latitude
          longitude
          fwVersion
          lastGatewayRoute
          ocurrences
          alertState
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
const FILTER_UNIFIED_ALERTS = gql`
query unifiedAlerts(
  $company: ID!
  $firstAlertDateTime: DateTime
  $lastAlertDateTime: DateTime
  $alertState: AlertState
  $alertDescription: AlertDescription
  $installationReference: String
  $alertCode_In: [AlertCode] 
  $limit: Int
  $offset: Int
) {
  unifiedAlert(
    company: $company
    firstAlertDatetime: $firstAlertDateTime
    lastAlertDatetime: $lastAlertDateTime
    alertState: $alertState
    alertDescription: $alertDescription
    installationReference: $installationReference
    alertCode_In: $alertCode_In
    limit: $limit
    offset: $offset
  ) {
    edges {
      node {
        firstAlertDatetime
        lastAlertDatetime
        alertDbIndexedId
        alertCode
        eventsCount
        alertDescription
        installationReference
        installationId
        deviceSerialNumber
        deviceMacAddress
        latitude
        longitude
        fwVersion
        lastGatewayRoute
        occurrences
        alertState
        alertSource
      }
      cursor
    }
    pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
    }
  }
}
   
`;

const CHANGE_ALERT_STATUS = gql`
  mutation AlertStatusBulkUpdate($ids: [ID]!, $status: AlertStatus!) {
    alertStatusBulkUpdate(input: { ids: $ids, status: $status }) {
      alertsUpdated {
        id
        status
      }
      errors {
        id
        cause
      }
    }
  }
`;

const GET_EQUIPMENT_ALERT = gql`
  query SystemAlerts(
    $company: ID!
    $datetimeGte: DateTime!
    $datetimeLte: DateTime!
    $route: String
    $installations: [ID]
    $pageSize: Int
    $cursor: ID
  ) {
    systemAlerts(
      company: $company
      datetimeGte: $datetimeGte
      datetimeLte: $datetimeLte
      route: $route
      installations: $installations
      pageSize: $pageSize
      cursor: $cursor
    ) {
      total
      count
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          Id
          installation
          reference
          datetime
          eventCode
          route
          device {
            macAddress
            serialNumber
          }
          geoposition {
            latitude
            longitude
          }
          gateway {
            reference
          }
          division {
            reference
          }
        }
      }
    }
  }
`;
export {
  // Queries
  GET_ALERT_BY_ID,
  GET_EQUIPMENT_ALERT,
  FILTER_ALERTS,
  FILTER_UNIFIED_ALERTS,
  // Mutations
  CHANGE_ALERT_STATUS,
};
